<stages-dialog2 #dialog *ngIf="dialogElements">
	<stages-dialog-header></stages-dialog-header>
	<div class="content">
		<h1>{{ countMessageKey }}</h1>
		<ul class="list dense">
			<ng-container *ngFor="let entry of dialogElements">
				<li class="list-item">
					<div class="label">
						<div class="text center">
							<h4 [ngClass]="entry.class">{{ entry.label }}</h4>
							<h4
								class="error-color"
								*ngIf="entry.sameLabelExists"
								translate="process.element.dependentElementsList.confirmTemplate.sameNameExists"
							></h4>
						</div>
					</div>
				</li>
			</ng-container>
		</ul>
	</div>
	<footer>
		<div class="buttons">
			<button class="button sm cancel" (click)="close()" translate="cancel"></button>
			<button
				class="button sm save"
				(click)="applyTemplate()"
				[disabled]="dependentElementIdsWithoutDuplicates.length === 0"
			>
				<span *ngIf="!applyInProgress" translate="add"></span>
				<stages-spin *ngIf="applyInProgress" size="s"></stages-spin>
			</button>
		</div>
	</footer>
</stages-dialog2>
